import axios from "axios";

export function validateCacheControlAllowedValues(headerValue) {
  const allowedValues = ["no-cache"];

  if (!allowedValues.includes(headerValue)) {
    throw new Error(
      `Invalid Cache-Control header value: "${headerValue}". Allowed values are: ${allowedValues.join(
        ", "
      )}`
    );
  }
}

export default {
  methods: {
    addCacheControl(cacheControlHeader) {
      validateCacheControlAllowedValues(cacheControlHeader);

      let eject;
      const cacheControlInterceptor = axios.interceptors.request.use(
        (config) => {
          config.headers["Cache-Control"] = cacheControlHeader;
          eject();
          return config;
        },
        (error) => {
          eject();
          return Promise.reject(error);
        }
      );
      eject = () => axios.interceptors.request.eject(cacheControlInterceptor);
    },
  },
};
